import { combineReducers } from "redux";

import list from "./List/reducer";
import view from "./View/reducer";

const reportForDutyLogsReducer = combineReducers({
  list,
  view,
});

export default reportForDutyLogsReducer;
